import PropTypes from "prop-types"
import { useEffect } from "react"
import { useQuery } from "@tanstack/react-query"
import { useLocation } from "react-router-dom"
import { getSalonSlug } from "../../utils/salonHost"
import companyService from "../../services/company.service"
import { buildFounderSalonClientUrl } from "../../utils/salonUrls"
import PageLoadingShell from "../ui/pageLoadingShell"

const ClientSalonGate = ({ children }) => {
  const location = useLocation()
  const slug = getSalonSlug()

  const { data: companies, isPending } = useQuery({
    queryKey: ["companies", "public-list", "client-gate"],
    queryFn: () => companyService.listCompanies(),
    enabled: !slug,
    staleTime: 5 * 60 * 1000,
  })

  useEffect(() => {
    if (slug || isPending) return

    const targetPath = `${location.pathname}${location.search}${location.hash}`
    window.location.replace(buildFounderSalonClientUrl(targetPath, companies))
  }, [slug, isPending, companies, location])

  if (slug) {
    return children
  }

  return <PageLoadingShell />
}

ClientSalonGate.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

export default ClientSalonGate
